import { render } from "./Recuperacion.vue?vue&type=template&id=32b18428&scoped=true"
import script from "./Recuperacion.vue?vue&type=script&lang=js"
export * from "./Recuperacion.vue?vue&type=script&lang=js"

import "./Recuperacion.vue?vue&type=style&index=0&id=32b18428&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b18428"]])

export default __exports__